module.exports = __webpack_public_path__ + "static/media/blue.401f18d6.svg";